import {Controller} from "stimulus"
import $ from 'jquery';

import 'select2/dist/css/select2.css'
import 'select2-bootstrap-theme/dist/select2-bootstrap.css'

export default class extends Controller {

    initialize() {
        let element = this.element;
        $.ajax({
            url: location.origin + '/' + sessionStorage.getItem('locale') + '/frequently-answer-r',
            data: {},
            type: 'GET',
            success: function (data) {
                if (data.length > 0) {
                    let html = `<div class="page-body">
                                        <div class="page-description">
                                            <div id="accordion" class="accordion ">`
                    let i = 0;
                    data.map(faq => {
                        html += `
                            <div class="card">
                                <div class="card-header" id="headingOne">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link ${i !== 0 ? 'collapsed' : ''}" data-toggle="collapse" data-target="#collapse_${faq[0]}" aria-expanded="${i === 0 ? 'true' : 'false'}" aria-controls="collapseOne">
                                            ${faq[1]}
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapse_${faq[0]}" class="collapse ${i === 0 ? 'show' : ''}" aria-labelledby="headingOne" data-parent="#accordion">
                                    <div class="card-body">
                                        ${faq[2]}
                                    </div>
                                </div>
                            </div>`;

                        i = 1;
                    })

                    html += `</div></div></div>`

                    element.innerHTML = html;
                }
            }
        })
    }
}